module.exports = __webpack_public_path__ + "static/media/heart-active.c9d70ef3.svg";